module.exports = __webpack_public_path__ + "img/couples-056.2685d4c2.jpg";